import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
export default function FailureMatrix({
    cars = [],
    categoryLabel = "Conforto",
    systems = [],
    matrixData = {}
}) {

    return (

        <div style={styles.failureWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        <th style={{ width: "180px" }}></th>
                    </tr>
                </thead>

                <tbody>

                    {systems.map((system, index) => (

                        <tr key={system.key}>

                            {index === 0 && (

                                <td
                                    rowSpan={systems.length}
                                    style={styles.failureVertical}
                                >
                                    {categoryLabel}
                                </td>

                            )}

                            <td
                                style={{
                                    ...styles.failureLabel,

                                    borderTop:
                                        index === 0
                                            ? "1px solid #9ca3af"
                                            : "none",

                                    borderBottom:
                                        index === systems.length - 1
                                            ? "1px solid #9ca3af"
                                            : "none"
                                }}
                            >
                                {system.label}
                            </td>

                            {cars.map(car => {

                                const item =
                                    matrixData?.[car]?.[system.key];

                                return (

                                    <td
                                        key={car}
                                        style={styles.failureCell}
                                    >

                                        <span
                                            style={{
                                                ...styles.failureBadge,

                                                background:
                                                    item?.active
                                                        ? (
                                                            getCategoryColor(
                                                                item?.category
                                                            ) || "#ef4444"
                                                        )
                                                        : "#ffffff",

                                                color:
                                                    item?.active
                                                        ? "#ffffff"
                                                        : "#111827"
                                            }}
                                        >
                                            FALHA
                                        </span>

                                        <span
                                            style={{
                                                ...styles.failureBadgeLight,

                                                background: item?.secondary
                                                    ? (getCategoryColor(item?.secondaryCategory) || "#ef4444")
                                                    : "#ffffff",

                                                color: item?.secondary
                                                    ? "#ffffff"
                                                    : "#111827"
                                            }}
                                        >
                                            {"<50%"}
                                        </span>

                                    </td>
                                );
                            })}

                        </tr>
                    ))}

                </tbody>

                <tfoot>

                    <tr>

                        <td style={{ width: "40px" }}></td>

                        <td style={{ width: "180px" }}></td>

                        {cars.map(car => (

                            <td
                                key={car}
                                style={styles.failureHeader}
                            >
                                Carro {car}
                            </td>

                        ))}

                    </tr>

                </tfoot>

            </table>

        </div>
    );
}